<template>
  <div class="modal-card" style="width: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{
          `${category._id ? $t("common.edit") : $t("common.create")} ${$tc(
            "vending.category",
            1
          )}`
        }}
      </p>
    </header>

    <section
      class="modal-card-body"
      style="padding-top: 3rem; padding-bottom: 2rem;"
    >
      <div class="columns">
        <div class="column is-one-third">
          <div style="margin: auto;">
            <div
              class="category-image-div image container is-2by1"
              :class="category._id ? 'category-image-div-hover' : ''"
              style="height: 100px;"
              :style="{
                backgroundImage: category.image ? `url(${category.image})` : ''
              }"
              @click="category._id ? $refs.categoryImage.click() : null"
            >
              <input
                type="file"
                id="categoryImage"
                ref="categoryImage"
                style="display: none"
                accept="image/png, image/jpeg, image/jpg"
                @change="uploadCategoryImage"
              />
            </div>

            <p class="has-text-centered" v-if="category._id">
              {{ $t("vending.categoryImageDimensions") }}
            </p>

            <p class="has-text-centered" v-else>
              <b-icon
                icon="exclamation-circle"
                type="is-primary"
                style="position: relative; top: 6px;"
              ></b-icon>
              {{ $t("vending.onlyPossibleToChangeImageAfterCategoryCreation") }}
            </p>
          </div>
        </div>

        <div class="column is-one-third">
          <b-tooltip
            :label="$t('vending.notVisibleToClient')"
            position="is-top"
            style="width: 100%; margin-bottom: 1rem;"
          >
            <b-field
              :label="$t('vending.internalName')"
              label-position="on-border"
            >
              <b-input
                v-model="category.name"
                placeholder="Ex: Cervejas"
              ></b-input>
            </b-field>
          </b-tooltip>

          <b-tooltip
            :label="$t('vending.needPersonalId')"
            position="is-top"
            style="width: 100%;"
          >
            <b-field
              :label="$t('vending.forbiddenForMinors')"
              label-position="on-border"
            >
              <div class="block">
                <b-radio
                  v-model="category.forbiddenForMinors"
                  name="category.forbiddenForMinors"
                  :native-value="true"
                  style="position: relative; top: 0.75rem; left: 1rem;"
                >
                  {{ $t("common.yes") }}
                </b-radio>
                <b-radio
                  v-model="category.forbiddenForMinors"
                  name="category.forbiddenForMinors"
                  :native-value="false"
                  style="position: relative; top: 0.75rem; left: 1rem;"
                >
                  {{ $t("common.no") }}
                </b-radio>
              </div>
            </b-field>
          </b-tooltip>
        </div>

        <div class="column is-one-third">
          <b-tooltip
            :label="$t('vending.visibleToClient')"
            position="is-left"
            style="width: 100%; margin-bottom: 1rem;"
          >
            <b-field
              :label="$t('vending.ptBRTranslation')"
              label-position="on-border"
            >
              <b-input
                v-model="category.translations.pt_BR"
                placeholder="Ex: Beers"
              ></b-input>
            </b-field>
          </b-tooltip>

          <b-tooltip
            :label="$t('vending.visibleToClient')"
            position="is-left"
            style="width: 100%; margin-bottom: 1rem;"
          >
            <b-field
              :label="$t('vending.enTranslation')"
              label-position="on-border"
            >
              <b-input
                v-model="category.translations.en"
                placeholder="Ex: Beers"
              ></b-input>
            </b-field>
          </b-tooltip>

          <b-tooltip
            :label="$t('vending.visibleToClient')"
            position="is-left"
            style="width: 100%"
          >
            <b-field
              :label="$t('vending.esTranslation')"
              label-position="on-border"
            >
              <b-input
                v-model="category.translations.es"
                placeholder="Ex: Cervezas"
              ></b-input>
            </b-field>
          </b-tooltip>
        </div>
      </div>

      <div class="has-text-centered">
        <b-button
          class="button"
          :style="{
            backgroundColor: $primaryColor,
            color: $primaryColorContrast
          }"
          @click="createUpdateCategory"
        >
          {{ `${category._id ? $t("common.update") : $t("common.create")}` }}
        </b-button>
        &nbsp;&nbsp;
        <b-button
          class="button is-deep-purple"
          @click="deleteCategory"
          v-if="category._id"
        >
          {{ $t("common.delete") }}
        </b-button>
      </div>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { common } from "../../mixins/common";

export default {
  props: ["category"],

  mixins: [common],

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    createUpdateCategory() {
      if (!this.category._id) {
        this.createCategory();
      } else {
        this.updateCategory();
      }
    },

    createCategory() {
      this.isLoading = true;
      this.$store
        .dispatch("createVendingCategory", {
          category: this.category
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else if (res.data.result === "ok") {
            this.$parent.close();
            this.$emit("get-vending-categories");
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateCategory() {
      this.isLoading = true;
      this.$store
        .dispatch("updateVendingCategory", {
          category: this.category
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else if (res.data.result === "ok") {
            this.$buefy.toast.open({
              message: this.$t("vending.categoryUpdated"),
              type: "is-success",
              position: "is-bottom",
              duration: 3000
            });
            this.$parent.close();
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    deleteCategory() {
      this.isLoading = true;
      this.$store
        .dispatch("deleteVendingCategory", {
          categoryId: this.category._id
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: this.$t("vending.categoryDeleted"),
              type: "is-success",
              position: "is-bottom",
              duration: 3000
            });
            this.$parent.close();
            this.$emit("get-vending-categories");
          }
        })
        .catch(err => {
          this.alertError(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    uploadCategoryImage(event) {
      const formData = new FormData();
      let file = event.target.files[0];

      if (
        file.type !== "image/png" &&
        file.type !== "image/jpg" &&
        file.type !== "image/jpeg"
      ) {
        this.alertError({ message: "FILE_EXTENSION_NOT_ALLOWED_PNG_JPG_JPEG" });
        return;
      }

      if (file.size > 200000) {
        this.alertError({ message: "FILE_IS_TOO_LARGE_200" });
        return;
      }

      formData.append("file", file);
      formData.append("categoryId", this.category._id);

      this.isLoading = true;
      this.$store
        .dispatch("uploadFile", {
          to: "upload-vending-category-image",
          data: formData
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: this.$t("vending.imageUpdated"),
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
            this.category.image = res.data.payload.image;
          }
        })
        .catch(err => {
          this.alertError(err);
        })
        .finally(() => {
          this.isLoading = false;
          document.getElementById("categoryImage").value = null;
        });
    }
  }
};
</script>

<style scoped>
.category-image-div {
  background: center center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 100px;
  border: 1px solid rgb(150, 150, 150);
}
.category-image-div-hover:hover {
  opacity: 0.5;
  cursor: pointer;
}
</style>
